import Turbolinks from "turbolinks"

Turbolinks.start()